import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterLink } from '@angular/router';

import { IQObservation } from 'src/app/models/iq-observation.model';

@Component({
  selector: 'app-ons-widget-observations',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [DatePipe, RouterLink, MatProgressBarModule],
  template: `
    <div
      class="relative flex h-full flex-col overflow-hidden rounded-2xl border border-gray-50 bg-white p-6 shadow-lg"
    >
      @if (isLoading()) {
        <div
          class="pointer-events-none absolute left-0 top-0 h-full w-full bg-white/80"
        >
          <mat-progress-bar mode="indeterminate" />
        </div>
      }
      <div class="mb-4">
        <h2 class="text-xl text-gray-800">IQ Observations</h2>
        <p class="text-sm italic text-gray-400">
          (This output is generated using AI and may contain inaccuracies;
          please verify with source data before taking actions)
        </p>
      </div>
      <div class="flex-1 overflow-y-auto pr-2" style="max-height: 260px">
        @if (observations()?.length) {
          @for (obs of observations(); track obs) {
            <div class="mb-4 border-b border-gray-200 pb-3 last:mb-0">
              <div class="mb-1 flex justify-between text-xs text-gray-500">
                <div>
                  {{ obs.date + ' ' + obs.beginTime | date: 'short' }}
                </div>
              </div>
              <div class="whitespace-pre-line text-sm text-gray-700">
                {{ obs.summary }}
                @if (obs.caseLink) {
                  Case
                  <a
                    class="font-semibold text-blue-600 hover:text-blue-800"
                    [routerLink]="obs.caseLink.url"
                  >
                    {{ obs.caseLink.label }}
                  </a>
                  has been opened to track progress.
                }
              </div>
            </div>
          }
        } @else {
          <div class="py-8 text-center text-gray-400">
            No network performance degradation detected by the IQ analytics
            engine.
          </div>
        }
      </div>
    </div>
  `,
})
export class WidgetObservationsComponent {
  readonly observations = input<IQObservation[]>([]);

  readonly isLoading = input<boolean>(false);
}
